import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Profile() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", beach_location: user?.beach_location || "" });
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.patch("/auth/me", form);
      setUser(data);
      toast.success("Profile updated");
    } catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-lg space-y-6" data-testid="profile-page">
      <div>
        <div className="chip mb-2">Account</div>
        <h1 className="font-display text-3xl font-bold text-slate-900">Profile</h1>
        <p className="text-slate-600">Change your name and beach location.</p>
      </div>

      <form onSubmit={save} className="p-6 rounded-3xl bg-white border border-slate-200 space-y-3">
        <div>
          <label className="text-sm font-medium text-slate-700">Name</label>
          <input data-testid="profile-name" value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})}
            className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-100 outline-none" />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">Email</label>
          <input value={user?.email || ""} disabled className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-200 bg-slate-50 text-slate-500" />
        </div>
        {user?.role === "student" && (
          <div>
            <label className="text-sm font-medium text-slate-700">Local beach (for Beach Lab)</label>
            <input data-testid="profile-beach" value={form.beach_location} onChange={(e)=>setForm({...form, beach_location: e.target.value})}
              placeholder="e.g., Cocoa Beach, FL"
              className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-100 outline-none" />
          </div>
        )}
        <button data-testid="profile-save" disabled={saving} className="w-full py-3 rounded-full bg-teal-700 hover:bg-teal-800 text-white font-semibold transition-colors disabled:opacity-60">
          {saving ? "Saving…" : "Save"}
        </button>
      </form>
    </div>
  );
}
